@if (options) {
  <div
    highcharts-chart
    class="chart-block highcharts-light"
    [class.clickable]="!!eventContext"
    [sizeStrategy]="sizeStrategy"
    [runOutsideAngular]="true"
    [options]="options"></div>
}
